import { createSliceSelectors } from '../utils'

const AnalyticSelectors = createSliceSelectors('analytics', [
    'userkey',
    'sessionStartedAt',
    'analyticsInteractionCount',
])

export default AnalyticSelectors
